import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthPage } from './components/auth/AuthPage';
import { ChatPage } from './components/chat/ChatPage';
import { useAuthStore } from './stores/authStore';
import { useAppStore } from './stores/appStore';

function App() {
  const { isAuthenticated, user, tokens } = useAuthStore();
  const { theme, setTheme } = useAppStore();

  // Apply theme on mount
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  // Check token expiry
  useEffect(() => {
    if (tokens && tokens.expiresAt < Date.now()) {
      // Token expired, logout user
      useAuthStore.getState().logout();
    }
  }, [tokens]);

  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'dark' : ''}`}>
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={
            isAuthenticated ? <Navigate to="/app" replace /> : <AuthPage />
          } 
        />
        
        {/* Protected Routes */}
        <Route 
          path="/app" 
          element={
            isAuthenticated ? <ChatPage /> : <Navigate to="/login" replace />
          } 
        />
        
        {/* Default redirect */}
        <Route 
          path="/" 
          element={
            <Navigate to={isAuthenticated ? "/app" : "/login"} replace />
          } 
        />
        
        {/* Catch all */}
        <Route 
          path="*" 
          element={<Navigate to="/" replace />} 
        />
      </Routes>
    </div>
  );
}

export default App;
